<template>
  <section id="upload-section" class="upload-section">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6">
          <UploadArea
            @upload-success="handleUploadSuccess"
            @upload-error="handleUploadError"
          />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import UploadArea from '@/components/upload/UploadArea.vue';

const router = useRouter();
const store = useStore();

const handleUploadSuccess = (validatedData) => {
  store.commit('setAnalysis', validatedData);
  router.push({
    name: 'AnalysisHub',
    params: { id: validatedData.analysisId || 'current' },
  });
};

const handleUploadError = (error) => {
  console.error('Upload error:', error);
};
</script>

<style scoped>
.upload-section {
  padding: 2rem 0 3rem 0;
  background: var(--background);
}

@media (max-width: 600px) {
  .upload-section {
    padding: 1rem 0 2rem 0;
  }
}
</style> 
